import { ButtonClean, Fieldset } from '@fourthwall/components';
import React from 'react';
import { FormFields } from '../../hooks/useBadgeForm/types';
export const AddAnotherRule = ({ form }) => (React.createElement(Fieldset.Row, { inner: true },
    React.createElement(ButtonClean, { label: "Add another rule", withUnderline: true, onClick: () => {
            form.setFieldValue(FormFields.rules, form.values.rules.concat({
                type: 'EmptyRule',
            }));
        } })));
